<template>
  <div class="modal is-active">
    <div class="modal-background" @click="close()"></div>
    <div class="modal-card h-100">
      <p v-if="loading">Loading...</p>
      <section v-else class="modal-card-body d-block br-1">

        <header class="d-flex align-items-center pb-3 space-between">
          <h2 class="fs-8">Share this folder</h2>
          <button class="delete" @click="close"></button>
        </header>

        <section>
          <p>Select people or teams to share your video with from the dropdown. Start typing a name to filter the results.</p>
          <div class="d-flex align-items-center">
            <div class="w-100 mr-2">
              <v-select
                multiple
                class="v-select mt-0"
                v-model="selected"
                label="value"
                :options="shareables">
                <!--- http://sagalbot.github.io/vue-select/docs/Advanced/Templating.html --->
                <template slot="option" slot-scope="option">
                  <span><b v-if="option.team">Group:</b> {{ option.value }}</span>
                </template>
              </v-select>
            </div>
            <button
              @click="shareFolder"
              type='button'
              class='button is-primary is-medium'
              :disabled="selected.length === 0"
              :class="{ 'is-loading': sharingWithSelected }"
              name='Share'>
              Share
            </button>
          </div>
        </section>

        <section>
          <hr/>

          <p v-if="showShareText" class="text-center text-italic">
            This folder isn't shared with any person or team.
          </p>

          <h1 v-else class="fs-6 text-center">Shared With:</h1>
          <ul class="overflow-auto mh-35">
            <li v-for="fs in folder.shares" class="mb-1 d-flex justify-content-between">
              {{ fs.user.name || fs.user.email }}
               <input
                  @click="unshareFolder(fs.id)"
                  type='button'
                  :class="{ 'is-loading': fs.unsharing, 'w-auto': true }"
                  class='button is-small is-danger is-outlined'
                  value='✕ Unshare'
                />
            </li>
            <li v-for="ts in folder.teamshares" class="mb-1 d-flex justify-content-between">
               <div><b>Group:</b> {{ ts.name }}</div>
               <input
                  @click="unshareTeamFolder(ts.id)"
                  type='button'
                  :class="{ 'is-loading': ts.unsharing, 'w-auto': true }"
                  class='button is-small is-danger is-outlined'
                  value='✕ Unshare'
                />
            </li>
          </ul>
        </section>

      </section>
    </div>
  </div>
</template>

<script>
import store from '../store.js'
import vSelect from 'vue-select'

export default {
  name: 'ShareFolderModal',
  props: {
    folder: {
      required: true,
    },
  },
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
      selected: [],
      sharingWithSelected: false,
      loading: true,
    }
  },
  async mounted () {
    document.addEventListener('keyup', this.escapeKeyPress)
    await store.dispatch('fetchGroup')
    this.loading = false
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.escapeKeyPress)
  },
  computed: {
    shareables () {
      const shareUsers = store.state.user.is_diy ? store.state.user.colleagues : store.state.group.users
      return [
        ...store.state.user.teams
           .filter(team => this.folder.teamshares != null && this.folder.teamshares.find(x => x.id === team.id) == null)
           .map(team => ({
             value: team.name,
             label: 't-' + team.id,
             team: true,
           })),
        ...shareUsers
          .filter(user => this.folder.shares != null && this.folder.shares.find(x => x.user.id === user.id) == null)
          .filter(x => x.id !== store.state.user.id)
          .filter(x => !x.archived)
          .map(groupUser => ({
            value: groupUser.name || groupUser.email,
            label: 'u-' + groupUser.id,
          }))
      ]
    },
    showShareText () {
      // TODO
      return false
    },
  },
  methods: {
    escapeKeyPress (event) {
      if (event.keyCode === 27) {
        this.close()
      }
    },
    close () {
      this.$emit('close')
    },
    async shareFolder () {
      this.sharingWithSelected = true
      await Promise.all(this.selected.map(x => {
        const [ type, strid ] = x.label.split('-')
        const id = parseInt(strid)
        if (type === 't') {
          return store.dispatch('shareFolderWithTeam', { folderID: this.folder.id, teamID: id })
        } else {
          return store.dispatch('shareFolderWithUser', { folderID: this.folder.id, userID: id })
        }
      }))
      this.sharingWithSelected = false
      this.selected = []
    },
    unshareFolder (folderShareID) {
      store.dispatch('unshareFolderWithUser', { folderID: this.folder.id, folderShareID })
    },
    unshareTeamFolder (teamFolderShareID) {
      store.dispatch('unshareFolderWithTeam', { folderID: this.folder.id, teamFolderShareID })
    },
  },
}

</script>

<style lang="scss" scoped>

.w-auto{
  width: auto;
}

.v-select {
  position: relative;

  .dropdown-toggle {
    width: 100%;
  }

  input,
  .dropdown,
  .dropdown-toggle {
      width: 100%;
  }
}

.v-select .dropdown-menu {
  min-width: 100%;
  width: 100%;
}

</style>

<style lang="scss">

.v-select.dropdown {
  width: 100%;
}

.v-select .dropdown-toggle {
  width: 100%;
}

ul.dropdown-menu > li {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// ShareFolderModal.vue?298861a9